import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CompanyAction, SearchCompanyAction } from '../../../redux/actions/company';
import { COMPANY_RESET } from '../../../redux/constantes/company';

import { ContainerForm } from '../../../components/Containers';
import InputCompany from '../../../components/Company/InputCompany';
import { WrapperInputs } from '../../../components/SincronizaNFe/WrapperInputs';
import { WrapperButtons } from '../../../components/Company/WrapperButtons';
import { WrapperCompanies } from '../../../components/Company/WrapperCompanies';
import CompanyOption from '../../../components/Company/CompanyOption';
import ButtonSend from '../../../components/ButtonSend';
import ButtonBack from '../../../components/ButtonBack';
import { MessageBoxError, MessageBoxSuccess } from '../../../components/MessageBox';
import SelectState from '../../../components/Company/SelectState';
import HeaderTitle from '../../../components/HeaderTitle';
import SubTitleWrapper from '../../../components/SubTitleWrapper';

export default function TemplateCompanyReg() {
  const [name, setName] = useState('');
  const [category, setCategory] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [CEP, setCEP] = useState('');

  const { success, error } = useSelector((state) => state.createCompany);
  const { company: searchCompany, error: searchCompanyError } = useSelector((state) => state.searchCompany);
  const dispatch = useDispatch();

  useEffect(() => {
    if (searchCompanyError === 'Token inválido') {
      localStorage.removeItem('userInfo');
      document.location.href = '/login';
    }
  }, [searchCompanyError]);

  useEffect(() => {
    dispatch(SearchCompanyAction());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        dispatch({ type: COMPANY_RESET });
        document.location.href = '/';
      }, 3000);
    }
    if (error) {
      setTimeout(() => {
        dispatch({ type: COMPANY_RESET });
      }, 3000);
    }
  }, [dispatch, success, error]);

  const handleSubmit = () => {
    dispatch(CompanyAction(name, category, cnpj, address, city, state, CEP));
  };

  return (
    <ContainerForm>
      <HeaderTitle text="Cadastrar Empresas" linkIcon="/images/icons/building.svg" />
      <InputCompany
        id="name"
        label="Nome da Empresa"
        type="text"
        onChange={(e) => setName(e.target.value)}
        value={name}
        placeholder="Nome fantasia ou jurídico"
      />
      <InputCompany
        id="category"
        label="Categoria da Empresa"
        type="text"
        onChange={(e) => setCategory(e.target.value)}
        value={category}
        placeholder="Exemplo: Educação, Administração entre outros."
      />
      <InputCompany
        id="cnpj"
        label="CNPJ"
        type="text"
        onChange={(e) => setCnpj(e.target.value)}
        value={cnpj}
        placeholder="Digite apenas números"
      />
      <InputCompany
        id="address"
        label="Rua/Av. e Número"
        type="text"
        onChange={(e) => setAddress(e.target.value)}
        value={address}
        placeholder="Exemplo: Rua Nome da Rua, 32 - Nome do Bairro"
      />
      <WrapperInputs>
        <InputCompany
          id="city"
          label="Cidade"
          type="text"
          onChange={(e) => setCity(e.target.value)}
          value={city}
          placeholder="Exemplo: São Paulo"
        />
        <SelectState state={state} setState={setState} />
        <InputCompany
          id="CEP"
          label="CEP"
          type="text"
          onChange={(e) => setCEP(e.target.value)}
          value={CEP}
          placeholder="Digite apenas números"
        />
      </WrapperInputs>
      <WrapperButtons>
        <ButtonBack />
        <ButtonSend onClick={handleSubmit}>Cadastrar</ButtonSend>
      </WrapperButtons>
      <div>
        <SubTitleWrapper subTitle="Empresas Cadastradas" />
        <WrapperCompanies>
          {searchCompany && searchCompany.map((comp, index) => <CompanyOption key={index + 1} comp={comp} />)}
        </WrapperCompanies>
      </div>
      {error && <MessageBoxError>{error}</MessageBoxError>}
      {success && <MessageBoxSuccess>Empresa cadastrada com sucesso!</MessageBoxSuccess>}
    </ContainerForm>
  );
}
